import { Spin } from 'antd';
import { useEffect } from 'react';

import BoxContainer from 'base/ui/components/BoxContainer';
import { observer } from 'mobx-react';
import { CONNECT_ZALO } from 'utils/constants';

const createConnectZalo = () => {
  return observer(() => {
    useEffect(() => {
      window.location.replace(CONNECT_ZALO);
    }, []);

    return (
      <Spin spinning={true}>
        <BoxContainer fullHeight className="!h-screen">
          <div></div>
        </BoxContainer>
      </Spin>
    );
  });
};

export default createConnectZalo;
